export const HandleErrorBoundaryCatch = (props: { component: string; message: string }) => {
    const fullMessage = `ERROR in: ${props.component} >> ${props.message}`;
    console.error(fullMessage);
    return (
      <div style={{ display: 'none' }}>{fullMessage}</div>
    );
}